import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

export const usePremiumStatus = (user) => {
  const { userDoc, loading: authLoading, isAdmin: contextIsAdmin } = useAuth();
  const [docPremium, setDocPremium] = useState(false);
  const [claimPremium, setClaimPremium] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [premiumPlan, setPremiumPlan] = useState(null);
  const [premiumExpiresAt, setPremiumExpiresAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [evaluatedUid, setEvaluatedUid] = useState('');

  useEffect(() => {
    if (!user) {
      setDocPremium(false);
      setClaimPremium(false);
      setIsAdmin(false);
      setPremiumPlan(null);
      setPremiumExpiresAt(null);
      setEvaluatedUid('');
      setLoading(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setClaimPremium(false);
    setIsAdmin(Boolean(contextIsAdmin));

    (async () => {
      try {
        const token = await user.getIdTokenResult(true).catch(() => null);

        if (!active) return;

        const resolvedAdmin = Boolean(contextIsAdmin || token?.claims?.admin);
        const resolvedClaimPremium = Boolean(token?.claims?.premium || resolvedAdmin);

        setClaimPremium(resolvedClaimPremium);
        setIsAdmin(resolvedAdmin);
        setEvaluatedUid(user.uid);
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [contextIsAdmin, user]);

  useEffect(() => {
    if (!user) {
      setDocPremium(false);
      setPremiumPlan(null);
      setPremiumExpiresAt(null);
      return;
    }
    const data = userDoc || {};
    setDocPremium(Boolean(data.premium));
    setPremiumPlan(data.premiumPlan || null);
    setPremiumExpiresAt(data.premiumExpiresAt || null);
  }, [user, userDoc]);

  const isPremium = docPremium || claimPremium;
  const isResolvingCurrentUser = Boolean(user?.uid) && evaluatedUid !== user.uid;
  return {
    isPremium,
    isAdmin,
    premiumPlan,
    premiumExpiresAt,
    loading: authLoading || loading || isResolvingCurrentUser,
    evaluatedUid
  };
};
